<div>
  <div class="col-12 agendaCss">
    <p>Agende uma data e um horário para ser feito a atualização.</p>
  </div>
  <div class="col-12 agendaCss">
    <p-calendar showTime="true" hourFormat="24" [inline]="true" (onSelect)="onDateSelect($event)"></p-calendar>
  </div>
  <div class="button-container mt-2 col-12 agendaCss" style="text-align: right;">
    <button pButton type="button" label="Agendar" class="p-button-success" (click)="agendar()"></button>
  </div>
</div>